export function formatValue(value: string | null): string {
    if (value === null) {
        return '';
    }

    return value;
}
